const body = () =>
    import(
      /* webpackChunkName: "landing-routes" */ '@fremcast/template/DinamicSectionLoader'
      );
/**
 *
 * Here could be generated different types of Headers, such as:
 * 1. Landing
 * 2. Blog
 * 3. Video List
 * 4. Video preview
 */
const header = () =>
  import(
    /* webpackChunkName: "landing-routes" */ '@fremcast/template/DinamicHeaderLoader'
    );

const footer = () =>
  import(
    /* webpackeChunkName: "landing-routes" */ '@fremcast/template/DinamicFooterLoader'
    )

export default [
  { path: "/", redirect: "/home" },

  {
    path: '/preview/:sectionId/:blockId/:videoId',
    name: 'watch',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        '@fremcast/template/DinamicVideoPreview.vue'
      ),
    props: true
  },
  {
    path: '/:slug',
    name: 'videos',
    /*
    component: () =>
      import(
        /// webpackChunkName: "routes" /
        '@fremcast/template/DinamicSectionLoader.vue'
        ),
    */

    components: {
      headerCms: header,
      default: body,
      footerCms: footer
    }
  }
]
